<template>
  <b-row>
    <b-col class="col-lg-6 offset-lg-3 col-sm-12">
      <p class="text-left">
        We have sent a code to the phone number provided. Please enter the code below to confirm your identity.
      </p>
       <ConfirmationForm />
    </b-col>
  </b-row>
</template>

<script>
import ConfirmationForm from '@/components/ConfirmationForm.vue'

export default {
  name: 'Confirmation',
  components: {
    ConfirmationForm
  }
}
</script>
<style lang="less">
  .lead {
    text-align: left;
  }
</style>
